export const getVariantCookies = () => document.cookie.split('; ')
  .filter(row => row.startsWith('paper_monster_ab_test_') && row.endsWith('=true'))
  .map(row => row.split('=true')).map(r => r[0])

const purchaseDetails = (order) => {
  const itemName = `${order.plan.name} ${order.plan.frequency}`
  return {
    transaction_id: order.id,
    value: order.plan.annualRecurringRevenue,
    items: [
      {
        item_id: itemName,
        item_name: itemName,
        item_category: 'checkout',
        price: order.plan.annualRecurringRevenue,
        quantity: 1,
      },
    ],
  }
}

export const sendTransactionEvent = (order) => {
  if (window.gtag) {
    window.gtag('event', 'purchase', {
      ...purchaseDetails(order),
      ab_test_variant_pages_seen: getVariantCookies(),
    })
  }
}

// For a site with no gtag on the page: its tag manager forwards the purchase
// to analytics. Clearing ecommerce first keeps an earlier push from merging in.
export const sendDataLayerPurchaseEvent = (order) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ ecommerce: null })
  window.dataLayer.push({
    event: 'purchase',
    ecommerce: { ...purchaseDetails(order), currency: 'USD' },
  })
}

// Each site sends conversions to its own Ads account; a site with none sends none.
export const googleAdsConversion = (sendTo) => {
  if (window.gtag && sendTo) {
    window.gtag('event', 'conversion', { send_to: sendTo })
  }
}

// A blocked or absent pixel script leaves its global undefined, so each pixel
// call is skipped rather than thrown.
export const bingConversionTracking = () => {
  window.uetq?.push('event', 'FreeTrialFormSubmission', { event_category: 'FreeTrial', event_label: 'lead', event_value: '0' })
}

export const facebookTracking = (order) => {
  window.fbq?.('track', 'Purchase', { value: order.plan.amount, currency: 'USD' })
  window.fbq?.('track', 'StartTrial', { value: order.plan.amount, currency: 'USD', predicted_ltv: '0.00' })
}

export const fakePageView = () => {
  const args = { hitType: 'pageview', page: '/t/<?php echo $data["sku"]; ?>/order-success' }
  if (window.ga) {
    window.ga('send', args)
  } else {
    setTimeout(fakePageView, 200, args)
  }
}
